import { render, staticRenderFns } from "./ImportTransportFileFormBlock.vue?vue&type=template&id=62c99f38"
import script from "./ImportTransportFileFormBlock.vue?vue&type=script&lang=js"
export * from "./ImportTransportFileFormBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports